<template>
    <div class="container">
        <div class="card mb-2">
            <div class="card-header">Fromアドレス</div>
            <div class="card-body">
                <div class="row">
                    <div class="col-12 col-sm-4">
                        <select v-model.trim="mail_from" class="form-control mb-2">
                            <option value="">info@promeraia.com</option>
                            <option v-for=" (item, idx) in mail_from_list" :value="item" :key="idx">{{item}}</option>
                        </select>
                        <input v-model.trim="mail_from_nm" type="input" class="form-control" spellcheck=false placeholder="送信アドレス別名">
                    </div>
                </div>
            </div>
        </div>
        <div class="card mb-2">
            <div class="card-header py-2 text-muted">
                送信Group選択
            </div>
            <div class="card-body">
                <div class="row mb-3">
                    <div class="col-12 col-sm-4">
                        <!-- 送信対象 -->
                        <select v-model.trim="group_type" class="form-control mb-2">
                            <option value="user">登録済みユーザー</option>
                            <option value="partner">パートナー会社</option>
                        </select>
                        <!-- ユーザーリスト -->
                        <select v-show="group_type == 'user'" v-model.trim="group_id_user" class="form-control">
                            <option value="tech">すべての技術者</option>
                            <option value="company">すべての法人</option>
                            <option v-for="item in list.mail_group_info_user" :value="item.mail_group_id" :key="item.mail_group_id">{{item.mail_group_nm}}</option>
                        </select>
                        <!-- パートナーリスト -->
                        <select v-show="group_type == 'partner'" v-model.trim="group_id_partner" class="form-control">
                            <option value="partner">すべてのパートナー</option>
                            <option v-for="item in list.mail_group_info_partner" :value="item.mail_group_id" :key="item.mail_group_id">{{item.mail_group_nm}}</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <small class="col-12 col-sm-4">
                       <span v-if="showCnt">
                           グループ人数：{{member_cnt}}人
                       </span>
                       <span class="float-right text-primary">
                           <span class="px-2" @click="openEdit">
                                編集
                           </span>
                           <span class="px-2" @click="toDetail">
                                詳細
                           </span>
                       </span>
                    </small>
                </div>
            </div>
        </div>
        <!-- グループEdit -->
        <group-edit ref="groupEdit"></group-edit>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import GroupEdit from './GroupEdit'

    const gArr = ['tech', 'company', 'partner']
    const gArrNm = ['すべての技術者', 'すべての法人', 'すべてのパートナー']

    const MailFromList = ['partner@promeraia.com','gai.kou@promeraia.com','koumei.kobayashi@promeraia.com']
    //const MailFromNm = ['高 凱']

    export default {
        props:{
            list: Object
        },
        components: {
            GroupEdit,
        },
        data () {
            return {
                mail_from_list: MailFromList,
                mail_from: "",
                group_type: 'user',
                group_id_user: 'tech',
                group_id_partner: 'partner',
                mail_from_nm: 'Promeraia[プロメライア] '
            }
        },
        computed: {
            //mail_from_nm () {
            //    let mail_nm_str = "Promeraia[プロメライア] "
            //    if (this.mail_from) {
            //        let idx = this.mail_from_list.indexOf(this.mail_from)
            //        return mail_nm_str +  MailFromNm[idx]
            //    }
            //    return mail_nm_str
            //},
            group_id () {
                return this.group_type == 'user' ? this.group_id_user : this.group_id_partner
            },
            group_list_now () {
                return this.group_type == 'user' ? this.list.mail_group_info_user : this.list.mail_group_info_partner
            },
            is_const_id () {
                return gArr.includes(this.group_id) 
            },
            group_nm () {
                if (this.is_const_id) {
                    let idx =  gArr.indexOf(this.group_id) 
                    return gArrNm[idx]
                } else {
                    let group = this.getGroup(this.group_id)
                    return group.mail_group_nm
                }
            },
            member_cnt () {
                if (this.is_const_id) {
                    return '0'
                } else {
                    let group = this.getGroup(this.group_id)
                    return group.member_cnt
                }
            },
            showCnt () {
                return this.is_const_id ? false : true
            },
            ...mapGetters(['getSysMailInfo'])
        },
        methods: {
            openEdit () {
                this.$refs.groupEdit.openThis(this.group_type, this.group_id, this.group_nm)
            },
            toDetail () {
                this.$router.push({name:'SysMailGroup', params: {
                    type: this.group_type,
                    group: this.group_id
                }})
            },
            delGroupSelected (id) {
                let idx = this.group_list_now.findIndex(el => el.mail_group_id == id)
                this.group_list_now.splice(idx,1)
                if (this.group_type == 'user') {
                    this.group_id_user = 'tech'
                }
                if (this.group_type == 'partner') {
                    this.group_id_partner = 'partner'
                }
            },
            getMailFrom () {
                return this.mail_from
            },
            getMailFromNm () {
                return this.mail_from_nm
            },
            getMailGroup () {
                return this.group_id
            },
            getGroup (id) {
                return this.group_list_now.find(el => el.mail_group_id == id)
            },
            getGroupType () {
                return this.group_type
            },
            openMsg (lev, msg, key, id) {
                this.$parent.openMsg(lev, msg, key, id)
            },
        }
    }
</script>

<style lang="stylus" scoped></style>
